import React from 'react';

export const InventoryIcons = ({ name, icons, opacity, large }) => (
  <div className={`flex space-x-1 sm:space-x-2 opacity-${opacity} overflow-auto`}>
    {(icons || []).map((v, k) => (
      <img key={`icon-${k}`} alt={`${name}-icon-${k}`} src={v} className={large ? 'w-24 h-24' : 'w-16 h-16'} />
    ))}
  </div>
);
